import { AppRole } from "./role"
import { User } from "./user"

export type Member = {
  id: string
  created_at: string
  organization_id: string
  individual_id: string
  account_id: string
}

export type MemberDetails = {
  member: Member,
  account: User,
  roles_ids: string[],
}

export enum ScopeRefKind {
  ORGANIZATION = 'organization',
  WORKSPACE = 'workspace',
  CAMPAIGN = 'campaign',
}

export type ScopeRef = {
  kind: ScopeRefKind,
  id: string | null
}

export type GrantDetail =  {
  member_grant_id: string,
  app_grant_id: string,
  role: AppRole,
  scope: ScopeRef,
}

export type MemberRow = {
  id: string,
  name: string,
  email: string,
  role: string,
}